import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "cozyhome_cookie_consent";

export const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (!stored) setVisible(true);
  }, []);

  const decide = (value) => {
    window.localStorage.setItem(STORAGE_KEY, value);
    if (window.posthog) {
      if (value === "accepted") window.posthog.opt_in_capturing();
      else window.posthog.opt_out_capturing();
    }
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-consent-banner"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-0 bottom-0 z-[999] px-4 pb-4 sm:px-6 sm:pb-6"
        >
          <div className="mx-auto flex max-w-3xl flex-col gap-4 rounded-2xl border border-stone-200 bg-white p-5 shadow-2xl sm:flex-row sm:items-center sm:gap-6 sm:p-6">
            <Cookie className="hidden h-6 w-6 shrink-0 text-cognac sm:block" />
            <p className="flex-1 text-sm leading-relaxed text-stone-500">
              Nous utilisons un outil de mesure d'audience (PostHog) pour comprendre l'usage du site. Vous pouvez
              accepter ou refuser ce suivi ; les cookies indispensables à la connexion aux espaces privés restent
              actifs dans tous les cas.{" "}
              <a href="/cookies" className="font-semibold text-cognac hover:underline">
                En savoir plus
              </a>
            </p>
            <div className="flex shrink-0 gap-3">
              <button
                data-testid="cookie-consent-refuse-btn"
                onClick={() => decide("refused")}
                className="rounded-full border border-stone-300 px-5 py-2.5 text-sm font-semibold text-navy transition-colors duration-300 hover:border-navy"
              >
                Refuser
              </button>
              <button
                data-testid="cookie-consent-accept-btn"
                onClick={() => decide("accepted")}
                className="rounded-full bg-navy px-5 py-2.5 text-sm font-semibold text-white transition-colors duration-300 hover:bg-cognac"
              >
                Accepter
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
